var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeaderboardFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 50,
    viewBox: "0 0 98 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_758_1406)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.5177 16.25H60.25C60.9404 16.25 61.5 16.8096 61.5 17.5V35C61.5 35.6904 60.9404 36.25 60.25 36.25H37.75C37.0597 36.25 36.5 35.6904 36.5 35V15C36.5 14.3097 37.0597 13.75 37.75 13.75H47.0177L49.5177 16.25ZM47.75 21.25V31.25H50.25V21.25H47.75ZM52.75 25V31.25H55.25V25H52.75ZM42.75 27.5V31.25H45.25V27.5H42.75Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_758_1406"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(34 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaderboardFilled);
export default __webpack_public_path__ + "static/media/leaderboard-filled.cf0297b6bdf0201b4b711b2dedc55fae.svg";
export { ForwardRef as ReactComponent };